import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import VolumeUp from '@mui/icons-material/VolumeUp';
import VolumeOff from '@mui/icons-material/VolumeOff';
import { IconButton } from '@mui/material';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

// const images = [
//   {
//     label: 'San Francisco – Oakland Bay Bridge, United States',
//     imgPath:
//       'https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60',
//   },
//   {
//     label: 'Bird',
//     imgPath:
//       'https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60',
//   },
//   {
//     label: 'Bali, Indonesia',
//     imgPath:
//       'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250',
//   },
//   {
//     label: 'Goč, Serbia',
//     imgPath:
//       'https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60',
//   },
// ];

function CarruselNuevo(props) {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const [isAutoplayEnabled, setIsAutoplayEnabled] = React.useState(true);
  const [isMuted, setIsMuted] = React.useState(true); // Inicialmente silenciado por reglas del navegador
  const images = props.datos;
  const maxSteps = images.length;

  const pausarCarrusel = () => setIsAutoplayEnabled(false);
  const reanudarCarrusel = () => setIsAutoplayEnabled(true);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };
  
  return (
    <Box sx={{ maxWidth: '100%', flexGrow: 1 }}>
      <Paper
        square
        elevation={0}
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: 50,
          pl: 2,
          bgcolor: 'background.default',
        }}
      >
        {/* <Typography>{images[activeStep].label}</Typography> */}
        <IconButton
          onClick={() => setIsMuted(!isMuted)}
          sx={{
            position: 'relative',
            top: 10,
            right: 10,
            zIndex: 10,
            bgcolor: 'rgba(0, 0, 0, 0.6)',
            color: 'white',
            '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.8)' },
          }}
        >
          {isMuted ? <VolumeOff /> : <VolumeUp />}
        </IconButton>
      </Paper>
      <AutoPlaySwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        autoplay={isAutoplayEnabled} // 2. Vinculamos el estado al autoplay del carrusel
      >
        {images.map((step, index) => {
          // Detectamos si el archivo actual es un video
          const isVideo = step.filename && step.filename.split('.').pop().toLowerCase() === 'mp4';
          
          // Si es el paso activo y es un video, pausamos el carrusel de inmediato para que espere al video
          if (index === activeStep && isVideo && isAutoplayEnabled) {
            pausarCarrusel();
          }

          return (
            <div 
              key={step.caption}
              onMouseEnter={pausarCarrusel} // 3. Al entrar el mouse, detiene el carrusel
              onMouseLeave={() => {
                // 4. Al salir el mouse, solo reanuda si NO es un video (los videos se controlan por su final)
                if (!isVideo) reanudarCarrusel();
              }}
            >
              {Math.abs(activeStep - index) <= 2 ? (
                <Box
                  component={isVideo ? "video" : "img"}
                  autoPlay={isVideo} // Solo autoPlay nativo si es video
                  muted={isMuted}    // Obligatorio para que los navegadores permitan el autoPlay de video
                  controls={isVideo} // Opcional: muestra controles de video si lo deseas
                  onEnded={() => {
                    // 5. Cuando el video termina, reanudamos el carrusel y avanzamos al siguiente slide
                    reanudarCarrusel();
                    if (activeStep < images.length - 1) {
                      handleStepChange(activeStep + 1);
                    } else {
                      handleStepChange(0); // Reinicia al primer slide si era el último
                    }
                  }}
                  sx={{
                    height: window.innerHeight > 720 ? '75vh' : '50vh',
                    cursor: step.url && step.url !== '' ? 'pointer' : '',
                    overflow: 'hidden',
                    width: '100%',       // Recomendado para centrar el video/imagen
                    objectFit: 'contain', // Mantiene la proporción sin recortar el contenido
                    '&:hover': {
                      bgcolor: step.url && step.url !== '' ? 'primary.dark' : '',
                    },
                  }}
                  src={step.filename ? step.filename : step.imgPath}
                  alt={step.caption}
                  onClick={() => {
                    if (step.url && step.url !== '') {
                      props.Cambiar(step.url);
                    }
                  }}
                />
              ) : null}
            </div>
          );
        })}
      </AutoPlaySwipeableViews>
      <MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
          </Button>
        }
      />
    </Box>
  );
}

export default CarruselNuevo;
